var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2489 16.5138C16.7676 16.5138 17.9992 15.283 18 13.7643V13.7627V11.5735C16.997 11.5735 16.1846 10.7611 16.1838 9.75811C16.1838 8.75595 16.9962 7.9427 17.9992 7.9427H18V5.75351C18.0016 4.23405 16.7716 3.00162 15.253 3H15.2481H5.75189C4.23243 3 3.00081 4.23081 3 5.75027V5.75108V8.01324C3.96811 7.97919 4.77973 8.73649 4.81378 9.70459C4.81459 9.72243 4.81541 9.74027 4.81541 9.75811C4.81622 10.7595 4.00622 11.5719 3.00487 11.5735H3V13.7627C2.99919 15.2814 4.23081 16.5138 5.74946 16.5138H5.75027H15.2489Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8009 7.3079L11.3004 8.31898C11.349 8.4179 11.4431 8.48682 11.5525 8.50304L12.669 8.66601C12.9455 8.70655 13.055 9.04547 12.8555 9.23925L12.0479 10.0257C11.9685 10.1028 11.9328 10.2138 11.9507 10.3233L12.1412 11.4341C12.1882 11.709 11.9004 11.9182 11.6539 11.7884L10.6558 11.2638C10.5577 11.212 10.4409 11.212 10.3428 11.2638L9.34552 11.7884C9.09822 11.9182 8.81038 11.709 8.85741 11.4341L9.04795 10.3233C9.0666 10.2138 9.03011 10.1028 8.95065 10.0257L8.14389 9.23925C7.94444 9.04547 8.05389 8.70655 8.32957 8.66601L9.44606 8.50304C9.55552 8.48682 9.65038 8.4179 9.69903 8.31898L10.1977 7.3079C10.3209 7.05817 10.6777 7.05817 10.8009 7.3079Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.5de41d6ca04071776304a944e0f1e537.svg";
export { ForwardRef as ReactComponent };